// Lo que cuesta de verdad la facturación anual.
//
// POR QUÉ EXISTE. `price_annual` en las tablas de planes NO es lo que se cobra:
// es el equivalente mensual de pagar por año ($229 en Professional). Los precios
// anuales en Stripe son `interval: year`, o sea UN cargo de 12×. Toda la UI
// mostraba únicamente el equivalente mensual, así que el cliente leía "$229/mes
// facturado anual", ponía la tarjeta, y a los 14 días recibía un cargo de
// $2,748 que no había visto escrito en ninguna pantalla (projects#369).
//
// Cualquier superficie que ofrezca el ciclo anual debe enseñar `annualTotal`.

/** El cargo único que Stripe hace al terminar la prueba, en dólares. */
export const annualTotal = (monthlyEquivalent: number): number => monthlyEquivalent * 12;

/**
 * Lo que ahorra el año completo frente a pagar mes a mes, en dólares.
 * Sustituye al "~20%" redondeado: un porcentaje no le dice a nadie cuánto
 * dinero es, y aquí la cifra es de tres dígitos.
 */
export const annualSavings = (monthly: number, monthlyEquivalent: number): number =>
  (monthly - monthlyEquivalent) * 12;
